import { render, staticRenderFns } from "./ListButton.vue?vue&type=template&id=264c38a5&scoped=true"
import script from "./ListButton.vue?vue&type=script&lang=js"
export * from "./ListButton.vue?vue&type=script&lang=js"
import style0 from "./ListButton.vue?vue&type=style&index=0&id=264c38a5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264c38a5",
  null
  
)

export default component.exports